const Search = new function() {
    let searchButtons = [];
    let searchPanel = null;
    let closeButton = null;
    let searchInput = null;
    
    this.init = () => {
        searchPanel = document.querySelector('.sn-search');
        searchInput = searchPanel.querySelector('.sn-searchform__input');
        document.querySelectorAll('.sn-searcher').forEach(button => searchButtons.push(button));
        closeButton = searchPanel.querySelector('.sn-nav-button');

        searchButtons.forEach(button => button.addEventListener('click', this.open));
        closeButton.addEventListener('click', this.close)
        
    }

    this.open = (e) => {
        e.preventDefault();
        searchInput.value = '';
        searchPanel.classList.add('show');
    }
    
    this.close = (e) => {
        e.stopPropagation();
        e.preventDefault();
        searchPanel.classList.remove('show');
    }
}

export default Search